import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Air } from "@air/next-icons";
import { VisuallyHidden } from "@air/primitive-visually-hidden";
import Link from "next/link";
import { memo } from "react";
import { Routes } from "~/constants/routes";
import { NEW_TAB } from "~/constants/urls";
export const AirLogoLink = /*#__PURE__*/ memo(()=>/*#__PURE__*/ _jsxs(Link, {
        className: "mr-1 flex items-center justify-center",
        href: Routes.root,
        target: NEW_TAB,
        rel: "noopener noreferrer",
        children: [
            /*#__PURE__*/ _jsx(VisuallyHidden, {
                children: "Go to landing page"
            }),
            /*#__PURE__*/ _jsx(Air, {
                "aria-hidden": "true",
                className: "h-11 text-blue-9"
            })
        ]
    }));
AirLogoLink.displayName = "AirLogoLink";
